import { render, staticRenderFns } from "./InventoryHistoryReport.vue?vue&type=template&id=778ac843"
import script from "./InventoryHistoryReport.vue?vue&type=script&lang=js"
export * from "./InventoryHistoryReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports